import { SimpleResult } from "../dto";
import { Api, getCompanyId } from "../helpers";

export class SystemManagersApi {
  static async resetPassword(
    systemManagerId: number,
    abortController?: AbortController,
  ): Promise<SimpleResult<void> | undefined> {
    const companyId = getCompanyId();
    const requestUrl = `/api/v1/core/c/${companyId}/systemManagers/${systemManagerId}/reset_password`;
    const response = await Api.patch<SimpleResult<void> | undefined>(
      requestUrl,
      {},
      abortController,
    );

    return response?.data;
  }
}
